import React, { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { LiquidBackground } from "@/components/LiquidBackground";
import { ChatWidget } from "@/components/ChatWidget";
import { TabBar } from "@/components/TabBar";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import Splash from "@/pages/Splash";
import Legal from "@/pages/Legal";
import FAQItaly from "@/pages/FAQItaly";
import Verification from "@/pages/Verification";
import Browse from "@/pages/Browse";
import HowItWorks from "@/pages/HowItWorks";
import ListingDetail from "@/pages/ListingDetail";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import AuthCallback from "@/pages/AuthCallback";
import CreateListing from "@/pages/CreateListing";
import Dashboard from "@/pages/Dashboard";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";

function Shell() {
  const location = useLocation();
  const [chatOpen, setChatOpen] = useState(false);

  useEffect(() => {
    const open = () => setChatOpen(true);
    window.addEventListener("ppc:open-chat", open);
    return () => window.removeEventListener("ppc:open-chat", open);
  }, []);

  // Emergent OAuth callback — process before anything else
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }

  if (location.pathname === "/") {
    return (
      <>
        <LiquidBackground />
        <Splash />
      </>
    );
  }

  return (
    <div className="App flex min-h-screen flex-col">
      <LiquidBackground />
      <Navbar />
      <main className="flex-1">
        <Routes>
          <Route path="/home" element={<Landing />} />
          <Route path="/browse" element={<Browse />} />
          <Route path="/how-it-works" element={<HowItWorks />} />
          <Route path="/legal" element={<Legal />} />
          <Route path="/faq-italia" element={<FAQItaly />} />
          <Route
            path="/verification"
            element={
              <ProtectedRoute>
                <Verification />
              </ProtectedRoute>
            }
          />
          <Route path="/listing/:id" element={<ListingDetail />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/create-listing"
            element={
              <ProtectedRoute>
                <CreateListing />
              </ProtectedRoute>
            }
          />
          <Route
            path="/edit-listing/:id"
            element={
              <ProtectedRoute>
                <CreateListing />
              </ProtectedRoute>
            }
          />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
        </Routes>
      </main>
      <Footer />
      <ChatWidget open={chatOpen} setOpen={setChatOpen} />
      <TabBar onChat={() => setChatOpen((o) => !o)} />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Shell />
      <Toaster position="top-right" theme="dark" />
    </BrowserRouter>
  );
}

export default App;
